import { render, staticRenderFns } from "./telephoneDoctorDialog.vue?vue&type=template&id=2ba29ea8&scoped=true"
import script from "./telephoneDoctorDialog.vue?vue&type=script&lang=js"
export * from "./telephoneDoctorDialog.vue?vue&type=script&lang=js"
import style0 from "./telephoneDoctorDialog.vue?vue&type=style&index=0&id=2ba29ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba29ea8",
  null
  
)

export default component.exports